import Guid from "_shared/guids/guid";
import { LoaderFunctionArgs, redirect } from "react-router";

type Options = {
  // Where to go if URL shape is invalid
  baseRedirect: string;
  // Require :id?
  requireId?: boolean;
  // Validate :action
  allowedActions?: readonly string[];
};

export function makeWorkAgreementLoader(opts: Options) {
  const {
    baseRedirect,
    requireId = false,
    allowedActions,
  } = opts;

  return async function loader({ params }: LoaderFunctionArgs) {
    const id = params["id"];
    const action = params["action"];

    if (allowedActions && action && !allowedActions.includes(action)) {
      return redirect(baseRedirect);
    }

    if (requireId) {
      if (!id) {
        console.warn("Missing work agreement id in URL");
        return redirect(baseRedirect);
      }
      if (!Guid.isValid(id)) {
        console.warn(`Invalid work agreement id format: ${id}`);
        return redirect(baseRedirect);
      }
    }

    return null;
  };
}

export function withDefaultTab(
  defaultTab: string,
  inner?: (a: LoaderFunctionArgs) => Promise<Response | null> | Response | null
) {
  return async (args: LoaderFunctionArgs) => {
    const { request, params } = args;

    if (!params.pageTab) {
      const url = new URL(request.url);
      const basePath = url.pathname.replace(/\/+$/, ""); // trim trailing slash
      return redirect(`${basePath}/${defaultTab}${url.search}`);
    }

    return inner ? inner(args) : null;
  };
}

export const workLoader = makeWorkAgreementLoader({
  baseRedirect: "/work",
});

export const activeWorkAgreementLoader = makeWorkAgreementLoader({
  baseRedirect: "/work/active",
  allowedActions: ["view"],
});

export const archivedWorkAgreementLoader = makeWorkAgreementLoader({
  baseRedirect: "/work/archived",
  allowedActions: ["view"],
});
